<template>
  <el-dialog
      title="请选择团队"
      :visible.sync="centerDialogVisible"
      width="30%"
      append-to-body
      center>
    <ul>
      <li v-for="(team,i) in list" :key="team.id" class="fs16 flex mb15" @click="currIdx=i">
        <i class="el-icon-check fs20 color_main" v-if="i===currIdx"></i>
        <i v-else></i>
        {{ team.teamName }}
      </li>
    </ul>
    <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="sub">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
import {healthcheckService} from "@/modules/tj/services/healthcheck";

export default {
  name: "choose-team-dialog",
  data() {
    return {
      centerDialogVisible: false,
      list: [],
      currIdx: 0
    }
  },
  computed: {
    currTeam() {
      return this.list[this.currIdx];
    }
  },
  methods: {
    async open(list = []) {
      this.centerDialogVisible = true
      this.list = list;
      if (list.length === 0) {
        this.list = await healthcheckService.teamList();
      }
      //this.list = this.list.concat(list);
      this.setIdx();
    },
    setIdx() {
      this.currIdx = Math.max(this.list.findIndex(r => r.id === this.healthcheckBookTeam.id), 0);
    },
    sub() {
      this.$emit('submit', this.currTeam);
      this.close();
    },
    close() {
      this.centerDialogVisible = false;
    }
  },
}
</script>

<style scoped>
i {
  width: 30px;
}
</style>
